import { z } from 'zod';
import { isoDate } from './common.js';
import { ProjectStatus, ProjectDocumentType } from '../types/enums.js';
export const createProjectSchema = z.object({
    code: z.string().min(1).max(30),
    name: z.string().min(1).max(200),
    customerId: z.string().uuid(),
    custRef: z.string().nullable().optional(),
    address: z.string().min(1),
    postcode: z.string().min(2).max(12),
    status: z.nativeEnum(ProjectStatus).default(ProjectStatus.upcoming),
    startDate: isoDate.nullable().optional(),
    endDate: isoDate.nullable().optional(),
    value: z.number().nullable().optional(),
    manager: z.string().nullable().optional(),
    managerPhone: z.string().nullable().optional(),
    managerEmail: z.string().nullable().optional(),
    supervisorId: z.string().uuid().nullable().optional(),
    clientPMId: z.string().uuid().nullable().optional(),
    clientFMId: z.string().uuid().nullable().optional(),
    clientCMId: z.string().uuid().nullable().optional(),
    clsMgrId: z.string().uuid().nullable().optional(),
    geofenceRadiusM: z.number().int().positive().nullable().optional(),
    assignedManagers: z.array(z.string().uuid()).default([]),
    clientContacts: z.array(z.string().uuid()).default([]),
});
export const updateProjectSchema = createProjectSchema.partial();
export const projectQuerySchema = z.object({
    search: z.string().optional(),
    status: z.nativeEnum(ProjectStatus).optional(),
    customerId: z.string().uuid().optional(),
    manager: z.string().optional(),
});
export const addProjectDocumentSchema = z.object({
    name: z.string().min(1),
    type: z.nativeEnum(ProjectDocumentType),
    notes: z.string().nullable().optional(),
    ref: z.string().nullable().optional(),
    date: isoDate.nullable().optional(),
    url: z.string().nullable().optional(),
});
//# sourceMappingURL=project.js.map